<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3>{{ phase }} Phase</h3>
      </div>
      <div class="card-body">
        <validation-observer ref="simpleRules">
          <b-form>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label for="type">Boq</label>
                  <a
                    v-if="parentObj4 && parentObj4.boq"
                    :href="parentObj4 ? parentObj4.boq.url : '' "
                    target="_blank"
                  ><small style=" float: right;">View Old
                    File?</small></a>
                  <validation-provider
                    #default="{ errors }"
                    name="boq"
                    :rules="customRules"
                  >
                    <b-form-file
                      v-model="phaseFour.boq"
                      :file-name-formatter="formatNames"
                      accept=".pdf"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="waiverDocument">High End Design</label>
                  <a
                    v-if="parentObj4 && parentObj4.highEndDesign"
                    :href="parentObj4 ? parentObj4.highEndDesign.url : '' "
                    target="_blank"
                  ><small
                    style=" float: right;"
                  >View Old File?</small></a>
                  <validation-provider
                    #default="{ errors }"
                    name="highEndDesign"
                    :rules="customRules"
                  >
                    <b-form-file
                      v-model="phaseFour.highEndDesign"
                      :file-name-formatter="formatNames"
                      accept=".pdf"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="mediumEndDesign">Medium End Design</label>
                  <a
                    v-if="parentObj4 && parentObj4.mediumEndDesign"
                    :href="parentObj4 ? parentObj4.mediumEndDesign.url : '' "
                    target="_blank"
                  ><small
                    style=" float: right;"
                  >View Old File?</small></a>
                  <validation-provider
                    #default="{ errors }"
                    name="mediumEndDesign"
                    :rules="customRules"
                  >
                    <b-form-file
                      v-model="phaseFour.mediumEndDesign"
                      :file-name-formatter="formatNames"
                      accept=".pdf"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group>
                  <label for="completionForm">Completion Form</label>
                  <a
                      v-if="parentObj4 && parentObj4.completionForm"
                      :href="parentObj4 && parentObj4.completionForm && parentObj4.completionForm.url "
                      target="_blank"
                  ><small style=" float: right;">View Old File?</small></a>
                  <validation-provider
                      #default="{ errors }"
                      name="completionForm"
                      :rules="customRules"
                  >
                    <b-form-file
                        v-model="phaseFour.completionForm"
                        :file-name-formatter="formatNames"
                        accept=".pdf"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                md="12"
                style="display: flex; justify-content: end;"
              >
                <button
                  id="submit-phase4"
                  type="button"
                  class="btn btn-outline-primary mt-2"
                  @click.prevent="validationForm"
                >
                  <feather-icon
                    icon="Edit2Icon"
                    class="mr-25"
                  />
                  Submit
                </button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'

import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormDatepicker, BFormFile,
} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { codeBasic } from './code'
import phaseFourService from '@/services/project/phaseFourService'
import designTypesService from '@/services/settings/designTypesService'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BFormFile,
    BFormDatepicker,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
  },
  props: ['phase', 'parentObj4'],
  data() {
    return {
      customRules: 'required',
      loading: false,
      phaseFour: {
        boq: null,
        highEndDesign: null,
        completionForm: null,
        mediumEndDesign: null,
      },
      required,
      password,
      email,
      confirmed,
    }
  },
  mounted() {
    this.getdesignTypesService()
    this.$watch(() => this.tab, val => {
      this.choosenTab = val
    })
    this.$watch(() => this.parentObj4, parentObj => {
      if (parentObj !== null) {
        this.customRules = ''
        this.phaseFour = {
          boq: null,
          highEndDesign: null,
          completionForm: null,
          mediumEndDesign: null,
        }
      }
    })
  },
  methods: {
    getdesignTypesService() {
      this.loading = true
      designTypesService.index()
        .then(response => {
          this.loading = false
          this.designTypes = response.data.data
        })
    },
    formatNames(files) {
      if (files.length === 1) {
        return files[0].name
      }
      return `${files.length} files selected`
    },
    validationForm() {
      document.getElementById('submit-phase4').setAttribute('disabled', 'disabled')
      this.loading = true
      this.$refs.simpleRules.validate().then(success => {

        if (success) {

          phaseFourService.post(this.$route.params.id, this.phaseFour)
            .then(response => {
              if (response && response.status === 200) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'success',
                    text: 'Phase Four Is Updated Successfully !',
                  },
                })
              }
              this.$emit('refreshPanel', 'true')
              this.loading = false
            })
          setTimeout(function(){
            document.getElementById('submit-phase4').removeAttribute('disabled')
          }, 5000)
        }
        else{
          document.getElementById('submit-phase4').removeAttribute('disabled')
        }
      }).catch(error => {
        Promise.reject(error)
        setTimeout(function(){
          document.getElementById('submit-phase4').removeAttribute('disabled')
        }, 5000)
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
